import { isPlatformServer } from '@angular/common';
import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { SSR_REQUEST_CONTEXT } from '@constants/ssr-request.token';
import { PartnerService } from '@services/feature-service/partner.service';
import { LoggerService } from '@services/util-service/logger.service';
import { catchError, map } from 'rxjs/operators';

export const HttpTokenInterceptor: HttpInterceptorFn = (request, next) => {
  const partnerService = inject(PartnerService);
  const headers: { [name: string]: string | string[] } = {};

  if (partnerService?.accessToken) {
    headers['Authorization'] = `Bearer ${partnerService?.accessToken}`;
  }

  request = request.clone({ setHeaders: headers });
  return next(request);
}

export const HttpErrorInterceptor: HttpInterceptorFn = (request, next) => {
  const partnerService = inject(PartnerService);
  const platformId = inject(PLATFORM_ID);
  const ssrContext = isPlatformServer(platformId) ? inject(SSR_REQUEST_CONTEXT, { optional: true }) : null;
  const headers: { [name: string]: string | string[] } = {};

  if (partnerService?.accessToken) {
    headers['Authorization'] = `Bearer ${partnerService?.accessToken}`;
  }

  request = request.clone({ setHeaders: headers });
  return next(request).pipe(
    map(event => {
      if (event instanceof HttpResponse) {
        const body = event.body as any;
        if (body?.errors && body.errors?.length) {
          throw new HttpErrorResponse({
            error: new Error(body.errors[0].message),
            statusText: body.errors[0].message,
            status: body.errors[0].code
          });
        }
        return event;
      }
      return event;
    }),
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        LoggerService.warn('Authentication failed!');
      }
      const ssrInfo = ssrContext
        ? `| IP: ${ssrContext.ip} | UA: ${ssrContext.userAgent} | Referer: ${ssrContext.referer} | SSR URL: ${ssrContext.url}`
        : '';
      LoggerService.error(
        `[HTTP ${error.status}] ${request.method} ${request.urlWithParams}`,
        request.body ? `| Payload: ${JSON.stringify(request.body)}` : '',
        `| Error: ${error.message}`,
        ssrInfo
      );
      throw error;
    })
  );
}

